exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.license-usage { display: inline-block; width: 96%;}\r\n.ng2-nouislider { float: right; width: 4%; text-align: center; margin: 0 auto;}\r\n.session-length { width: 100%; float: left; margin-top: 20px;}\r\n\r\n#usage-select-box select { width: auto; margin-bottom: 10px;}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/denials-day/denials-day.component.css
// module id = ../../../../../src/app/reports/myReports/denials-day/denials-day.component.css
// module chunks = main